<div class="grid-6 copo-container">
	<div class="grid-column-one-full card-info-block">
		<ng-container *ngIf="mills else loading">
			<ng-container *ngIf="mills.length > 0">
				<div class="card-content-title" translate>ecall-off.mill-section</div>
				<div class="card-content-label required" translate>ecall-off.select-a-mill</div>

				<mat-checkbox class="mills-spacing bold" [checked]="status === 'AllChecked'" [disabled]="isValidating"
					[indeterminate]="status === 'SomeChecked'" (click)="setAll($event)">
					{{ 'filter.all' | translate }}
				</mat-checkbox>
				<mat-checkbox *ngFor="let mill of mills; let i = index;" [checked]="mill.selected" [disabled]="isValidating"
					(click)="onToggle($event, mill)" class="mills-spacing">
					{{ mill.description }}
					</mat-checkbox>
			</ng-container>
		</ng-container>
		<ng-template #loading>
			<copo-loading-spinner></copo-loading-spinner>
		</ng-template>
	</div>
</div>